import { PluginFactory } from "./types"
import { RenderInput, Resolution, Unit } from "../types"

export enum LinebreakStrategy {
    None = 'none',
    Word = 'word',
    All = 'all',
}

type LinebreakStrategyExcecuter = (input: RenderInput, resolution: Resolution) => RenderInput

type LinebreakStrategMap = {
    [key in LinebreakStrategy]: LinebreakStrategyExcecuter
}

type PluginProps = {
    strategy?: LinebreakStrategy
}

const none: LinebreakStrategyExcecuter = (input) => input

export const all: LinebreakStrategyExcecuter = (input, resolution) => {
    let returnInput: RenderInput = []

    input.forEach(row => {
        if (row.length > resolution.width) {
            let processRow = [...row]
            do {
                returnInput.push(processRow.splice(0, resolution.width))
            } while(processRow.length > resolution.width && processRow.length !== row.length)
            returnInput.push(processRow)

        } else {
            returnInput.push(row)
        }
    })
    return returnInput
}

export const word: LinebreakStrategyExcecuter = (input, resolution) => {
    let returnInput: RenderInput = []
    let processInput = [...input]
    processInput.forEach(row => {
        
        if (row.length > resolution.width) {
            let processRow = [...row]
            do {
                returnInput.push(processRow.splice(0, findWorkBreakPosition(processRow, resolution.width)))
            } while(processRow.length > resolution.width && processRow.length !== row.length)
            returnInput.push(processRow)
            
        } else {
            returnInput.push(row)
        }
    })

    return returnInput
}

const findWorkBreakPosition = (row: Unit[], at: number) => {
    let pos = at
    row.slice(0, at).reverse().every((unit: Unit, index) => {
        if (unit === " ") {
            pos = at - index
            return false
        }
        return true
    })
    return pos
}

const useLinebreak: PluginFactory<PluginProps> = ({ strategy = LinebreakStrategy.Word } = {}) => {
    const map: LinebreakStrategMap = {
        none,
        all,
        word,
    }

    return (input, tick, resolution) => {
        return map[strategy](input, resolution)
    }
}

export default useLinebreak
